import { Box, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { setActiveFlag, setActiveFlagAndPage } from "../../redux/slices/ccoAdvance";
import ConnectionModal from "../../components/Modals/ConnectionModal";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { t } from "i18next";
import DataGridCertifiedConnection from "./DataGridCertifiedConnection";
import DataGridNeedAtttentions from "./DataGridNeedAtttentions";
import "../../sass/base/myConnectionSection.scss";
const MyConnectionSection=() => {

      const [_tab1Fetched, setTab1Fetched] = useState(false);
      const [_tab2Fetched, setTab2Fetched] = useState(false);
      const dispatch = useDispatch<AppDispatch>();
      const { activeFlag } = useSelector((state: RootState) => state.ccoAdvance);
      const theme = useTheme();
      const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
           <div className="search-contact-container">
         <>
            <div className="mycco-search-header">
              <div className="header-left">
                <div className="cco_row cco_row_7">
                  <div className="cco_col cco_col_6">
                    <div className="cco_text cco_text_10">
                      <div className="cco_text_inner">
                        <h2>
                          <strong>
                            {t("MyCCOPro.SearchCandidate.myConnections")}
                          </strong>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
    
    
            </div>
            <div className="tab-div">
    
              <Box className={`header-tabs ${isMobile ? "mobile" : ""}`}>
                <Tabs
                  value={activeFlag}
                  onChange={(_e, newValue: number) => {
                    if (newValue === 1) {
                      setTab1Fetched(false);
                      dispatch(setActiveFlagAndPage({ flag: 1, page: 1 }));
                    } else {
                      setTab2Fetched(false);
                      dispatch(setActiveFlag(0));
                    }
                  }}
                  variant={isMobile ? "fullWidth" : "standard"}
                  scrollButtons={isMobile ? "auto" : false}
                 className="tabs"
                >
                  <Tab label={isMobile ? t("dataGrid.Certified") : t("dataGrid.CertifiedConnections")} value={1} />
                  <Tab style={{ padding: "0px 20px " }} label={isMobile ? t("dataGrid.NeedsAttention") : t("dataGrid.NeedsAttention")} value={0} />
                </Tabs>
              </Box>
            </div>

       <div className="ccoAdvance">
          <div className="cco_col">
            <div className="cco_row cco_row_38">
              <div className="cco_col">
                <div className="cco_group cco_group_myCredential">
                    {activeFlag===1 ?(
                <DataGridCertifiedConnection activeTab={activeFlag}/>
                    ):(
                    <DataGridNeedAtttentions activeTab={activeFlag}/>
                    )}
                  
   
                  <ConnectionModal />
                </div>
              </div>
            </div>

            <div className="pagination-top"></div>
          </div>
        </div>
        </>
           </div>

    )
}

export default MyConnectionSection